<template>
  <div>
    <section class="pt-5 mb-4 bg-white">
      <div class="container">
        <div class="row">
          <div class="col-md-6 mx-auto">
            <div class="d-flex justify-content-center">
              <div
                  class="pl-4 text-center "
                  style="color:#e62e04;padding-right:50px;"
              >
                <img
                    :src="getFileViewUrl(shopData.userLevel.icon)"
                    alt
                    class="ls-is-cached lazyloaded"
                    height="50"
                />
                <div>{{ $t(shopData.userLevel.name) }}</div>
              </div>
              <img
                  :src="getFileViewUrl(shopData.imgHead)"
                  alt="fashion product"
                  class=" ls-is-cached lazyloaded"
                  height="70"
              />
              <div class="pl-4 text-left">
                <h1 class="fw-600 h4 mb-0">
                  {{ shopData.name }}
                  <span class="ml-2"
                  ><i class="fa fa-check-circle" style="color:green"></i
                  ></span>
                </h1>
                <div class="d-flex mb-2">
                  <StarsComp class="mr-4" :star="shopData.stars"/>
                  <div v-if="shopData.depositMoney">{{$t('已缴纳的保证金')}}: {{formatMoney(shopData.depositMoney)}}</div>
                </div>
                <div class="location opacity-60">
                  {{ shopData.contact }}
                </div>
                <button v-if="'1'===paramMapAll['CHAT_OPEN']"
                        class="btn btn-sm btn-soft-primary"
                        @click="showChatModal"
                >
                  {{ $t("给商家留言") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--        <div v-if="shopData.pics" class="border-bottom mt-5"></div>-->
        <div class="border-bottom mt-5"></div>
        <div class="row align-items-center">
          <div class="col-lg-6 order-2 order-lg-0">
            <ul class="list-inline mb-0 text-center text-lg-left">
              <li
                  v-for="(item, index) in list"
                  :key="index"
                  class="list-inline-item"
              >
                <a
                    :class="{
                    'border-bottom': index === selectedIndex,
                    'border-primary': index === selectedIndex,
                    'border-width-2': index === selectedIndex
                  }"
                    class="text-reset d-inline-block fw-600 fs-15 p-3"
                    href="javascript:void(0)"
                    @click="changeTab(index)"
                >{{ $t(item.name) }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!--    <section v-if="selectedIndex === 0" class="mb-4">-->
    <!--      <div class="container">-->
    <!--        <div class="text-center mb-4">-->
    <!--          <h3 class="h3 fw-600 border-bottom">-->
    <!--            <span-->
    <!--              class="border-bottom border-primary border-width-2 pb-3 d-inline-block"-->
    <!--              >{{ $t("特色产品") }}</span-->
    <!--            >-->
    <!--          </h3>-->
    <!--        </div>-->
    <!--        <div class="row">-->
    <!--          <div class="col">-->
    <!--            <div-->
    <!--              class="aiz-carousel gutters-10 slick-initialized slick-slider"-->
    <!--              data-autoplay="true"-->
    <!--              data-dots="true"-->
    <!--              data-infinute="true"-->
    <!--              data-items="6"-->
    <!--              data-lg-items="4"-->
    <!--              data-md-items="3"-->
    <!--              data-sm-items="2"-->
    <!--              data-xl-items="5"-->
    <!--              data-xs-items="2"-->
    <!--            >-->
    <!--              <div class="slick-list draggable">-->
    <!--                <div-->
    <!--                  class="slick-track"-->
    <!--                  style="opacity: 1; width: 0px; transform: translate3d(0px, 0px, 0px);"-->
    <!--                ></div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </section>-->
    <section class="mb-4">
      <div class="container">
        <van-swipe
            v-if="selectedItem.name==='商店首页' && shopData.pics"
            ref="swipe"
            :autoplay="3000"
            class="aiz-carousel my-swipe mb-2"
            @change="onChange"
        >
          <van-swipe-item
              v-for="(pic, index) in (shopData.pics.split(','))"
              :key="index"
          >
            <img
                :src="getFileViewUrl(pic)"
                alt=""
                class="d-block mw-100 img-fit rounded shadow-sm overflow-hidden"
            />
          </van-swipe-item>
          <template #indicator>
            <ul class="slick-dots">
              <li
                  v-for="index of shopData.pics.split(',').length"
                  :key="index"
                  :class="{ 'slick-active': current === index }"
              >
                <button role="tab" tabindex="-1" type="button"/>
              </li>
            </ul>
          </template>
        </van-swipe>
        <!--        <div class="mb-4">-->
        <!--          <h3 class="h3 fw-600 border-bottom">-->
        <!--            <span-->
        <!--                class="border-bottom border-primary border-width-2 pb-3 d-inline-block"-->
        <!--            >-->
        <!--              {{ $t(selectedItem.subName || selectedItem.name) }}-->
        <!--            </span>-->
        <!--          </h3>-->
        <!--        </div>-->
        <van-empty
            v-if="!goodsList || goodsList.length === 0"
            :description="$t('没有找到符合条件的商品')"
        />
        <div
            v-else
            class="row gutters-5 row-cols-xxl-5 row-cols-lg-4 row-cols-md-3 row-cols-2"
        >
          <div v-for="goods in goodsList" :key="`${goods.shopId}_${goods.id}`" class="col mb-3">
            <ProductCard :item="goods"/>
          </div>
        </div>
        <PaginationComp
            :cur-page="curPage"
            :total-page="totalPage"
            @goto="goToPage"
        />
      </div>
    </section>
    <ProductQueryModal ref="productQueryModal"/>
  </div>
</template>
<script>
import StarsComp from "@/components/StarsComp.vue";
import ProductCard from "@/components/ProductCard.vue";
import PaginationComp from "@/components/PaginationComp.vue";
import {getShopById} from "@/api/userShop";
import ProductQueryModal from "@/components/ProductQueryModal.vue";

export default {
  name:'ShopView',
  components: {ProductQueryModal, PaginationComp, ProductCard, StarsComp},
  props: {
    item: Object
  },
  data() {
    return {
      shopData: {
        userLevel: {},
      },
      list: [
        {
          name: "商店首页",
          subName: "新到货产品",
          orders: [{column: "`userShopGoods.createTime`", asc: false}]
        },
        {name: "最畅销", orders: [{column: "`userShopGoods_storeGoods.sales`", asc: false}]},
        {name: "所有产品"}
      ],
      selectedIndex: 0,
      totalPage: 0,
      curPage: 0,
      current: 0,
      goodsList: []
    };
  },
  computed: {
    selectedItem() {
      return this.list[this.selectedIndex];
    }
  },
  watch: {
    '$route.query.shopId'(newVal) {
      this.shopId = newVal
      this.getShopData();
      this.refresh();
    }
  },
  methods: {
    showChatModal() {
      this.$refs.productQueryModal.show(null, this.shopData.userId);
    },
    onChange(index) {
      this.current = index + 1;
    },
    async getShopData() {
      const res = await getShopById(this.shopId);
      this.shopData = res.data;
    },
    changeTab(index) {
      this.selectedIndex = index;
      this.refresh();
    },
    async pageGoods() {
      const pageSize = 20;
      const res = await this.$get("/goods/pageBuyer", {
        params: {
          curPage: this.curPage,
          pageSize,
          shopId: this.shopId,
          orders: this.selectedItem.orders,
          featureFlag: this.selectedItem.featureFlag
        }
      });
      this.goodsList = res.data.records;
      this.totalPage = Math.ceil(parseInt(res.data.total) / pageSize);
      window.scrollTo(0, 0);
    },
    goToPage(page) {
      if (typeof page !== "number" || page < 1 || page > this.totalPage) return;
      this.curPage = page;
      this.pageGoods();
    },
    refresh() {
      this.curPage = 1;
      this.pageGoods();
    }
  },
  created() {
    this.shopId = this.$route.query.shopId;
    this.getShopData();
    this.refresh();
  }
};
</script>
